(function () {
  angular.module("akitabox.ui.dialogs.printInspectionProgram", ["ngMaterial"]);
})();
